import "flatpickr/dist/themes/material_blue.css";
import PropTypes from "prop-types";
import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useToasts } from "react-toast-notifications";
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Progress,
  Row,
} from "reactstrap";
import {
  downloadReportInvoice,
  getReportInvoiceProgress,
  resetDownloadReportInvoice,
  resetGetReportInvoiceProgress,
} from "store/summary-invoice-data/actions";
import {
  DOWNLOAD_REPORT_INVOICE_FAIL,
  DOWNLOAD_REPORT_INVOICE_SUCCESS,
} from "store/summary-invoice-data/actionTypes";
import { getTimeContent } from "./helper/functionHelper";

const DetailReport = props => {
  const { isOpenModal, dataDetail, toggleModal, typeExport } = props;
  const dispatch = useDispatch();
  // store reducer
  const summaryInvoiceData = useSelector(state => state.summaryInvoiceData);
  const { reportInvoiceProgress, type: typeReport } = summaryInvoiceData;

  const { type, fileDownload, fileDownloadName, loadingDownload } =
    summaryInvoiceData;
  const { addToast } = useToasts();

  useEffect(() => {
    switch (typeReport) {
      case DOWNLOAD_REPORT_INVOICE_SUCCESS: {
        if (fileDownload !== null) {
          const link = document.createElement("a");
          link.href = fileDownload;
          link.setAttribute("download", fileDownloadName);
          document.body.appendChild(link);
          link.click();
        }
        addToast("Tải xuống thành công", {
          appearance: "success",
          autoDismiss: true,
        });
        dispatch(resetDownloadReportInvoice());
        break;
      }
      case DOWNLOAD_REPORT_INVOICE_FAIL:
        addToast("Tải xuống thất bại", {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetDownloadReportInvoice());
        break;
    }
  }, [typeReport]);

  useEffect(() => {
    if (isOpenModal) {
      console.log("🚀 ~ 1. Get Report Progress", {
        dataDetail,
        typeExport,
      });
      dispatch(getReportInvoiceProgress(dataDetail.id, true, typeExport));
    } else {
      dispatch(resetGetReportInvoiceProgress());
    }
  }, [isOpenModal]);

  useEffect(() => {
    // Tiến độ 100% thì gọi query hóa đơn
    if (
      !reportInvoiceProgress.isStart &&
      reportInvoiceProgress?.percent === 100
    ) {
    }
  }, [reportInvoiceProgress]);

  const modal = useRef(null);

  return (
    <React.Fragment>
      <Modal
        isOpen={isOpenModal}
        toggle={toggleModal}
        size="xl"
        role="dialog"
        autoFocus={true}
        centered={true}
        className="exampleModal"
        contentClassName="detail-data-format"
        style={{ maxWidth: "99%" }}
      >
        <ModalHeader toggle={toggleModal}>Tiến Độ Xử Lý</ModalHeader>
        <React.Fragment>
          <ModalBody>
            <Row className="d-flex justify-content-center">
              <div style={{ width: "50vw" }}>
                <div
                  className="d-flex justify-content-center align-items-end gap-2"
                  style={{ fontSize: "17px" }}
                >
                  {/* <i className=" far fa-file-excel text-success font-size-20" /> */}
                  {/* <strong>{nameFile + ".xlsx "}</strong> */}
                  {reportInvoiceProgress.percent === 100
                    ? ""
                    : "(Đang xử lý dữ liệu)"}
                </div>
                <Progress
                  style={{ height: "33px" }}
                  animated
                  color={`${
                    reportInvoiceProgress.percent === 100
                      ? "success"
                      : "warning"
                  }`}
                  striped
                  value={reportInvoiceProgress.percent}
                >
                  <span style={{ fontSize: "20px" }}>
                    {reportInvoiceProgress.percent === 100 && "Hoàn tất xử lý"}{" "}
                    ({reportInvoiceProgress.percent + "%"})
                  </span>
                </Progress>
              </div>
              <div
                style={{
                  display: "flex",
                  gap: "15px",
                  justifyContent: "center",
                  fontSize: "18px",
                  marginTop: "10px",
                  lineHeight: "15px",
                  alignItems: "center",
                }}
              >
                <div className="text-primary">Id Report: {dataDetail?.id}</div>
                {getTimeContent(dataDetail?.parameters) && (
                  <div className="text-info">
                    Thời gian thống kê: {getTimeContent(dataDetail?.parameters)}
                  </div>
                )}
              </div>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button
              type="button"
              color="danger"
              className="me-2"
              onClick={toggleModal}
            >
              Đóng
            </Button>
            {reportInvoiceProgress?.percent === 100 && (
              <Button
                color="success"
                className="btn-label"
                type="button"
                disabled={
                  reportInvoiceProgress?.percent !== 100 || loadingDownload
                }
                onClick={() => {
                  dispatch(
                    downloadReportInvoice(
                      dataDetail.id,
                      dataDetail.fileName,
                      //   +
                      //     getTimeContent(dataDetail.parameters)
                      "blob",
                      dataDetail.pathType,
                      typeExport
                    )
                  );
                }}
              >
                <i
                  className={` ${
                    loadingDownload
                      ? "bx bx-loader bx-spin "
                      : "bx bx-download "
                  } label-icon`}
                  style={{
                    background: "transparent",
                  }}
                ></i>
                Download file
              </Button>
            )}
          </ModalFooter>
        </React.Fragment>
      </Modal>
    </React.Fragment>
  );
};

DetailReport.propTypes = {
  isOpenModal: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
  dataDetail: PropTypes.object,
  t: PropTypes.any,
  typeExport: PropTypes.string,
};

DetailReport.defaultProps = {
  isOpenModal: false,
};

export default DetailReport;
